import { Button } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const InitiateNewEnvButton = ({ handleOnClick }) => {
  const colors = useColors();

  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: colors.feasibility_high_bg,
        "&:hover": {
          backgroundColor: colors.feasibility_high_bg_hover,
        },
      }}
      onClick={handleOnClick}
    >
      Initiate New Env
    </Button>
  );
};

export default InitiateNewEnvButton;
